module.exports = __webpack_public_path__ + "5b2de8995d7a36d42c1e24162a9ab2c0.svg";